import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "I run a small delivery fleet in Brooklyn. SECQRE replaced our dispatch board for 'who's blocking the dock' calls. We saved an hour a day in week one.",
    name: "Diego R.",
    role: "Operations Lead · Brooklyn, NY",
    stars: 5,
  },
  {
    quote: "I park at a public charger every day. SECQRE means I get a polite ping the moment my session ends instead of a passive-aggressive note. Game-changer.",
    name: "Priya S.",
    role: "EV driver · Austin, TX",
    stars: 5,
  },
  {
    quote: "We were using paper notes for years. The first time someone scanned the SECQRE tag and reached us in 5 seconds, my partner said 'why didn't this exist sooner?'",
    name: "Marcus & Lena",
    role: "Couple · Portland, OR",
    stars: 5,
  },
  {
    quote: "The masked call feature alone is worth 10× the sticker. I've gotten zero spam since switching. Zero.",
    name: "Anthony G.",
    role: "Property Manager · Miami, FL",
    stars: 5,
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="section-pad bg-white">
      <div className="container-secqre">
        <div className="max-w-2xl mb-12">
          <span className="overline">— Loved by drivers</span>
          <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl tracking-tight" data-testid="testimonials-heading">
            From paper notes to peace of mind.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure key={i} className="rounded-2xl border border-[#E2E8F0] bg-white p-7 transition-all hover:-translate-y-1 hover:border-[#0F172A]/40" data-testid={`testimonial-${i}`}>
              <Quote className="w-7 h-7 text-[#FFD600]" />
              <blockquote className="mt-5 text-[#0A0A0A] leading-relaxed">{t.quote}</blockquote>
              <figcaption className="mt-6 pt-6 border-t border-[#E2E8F0]">
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: t.stars }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-[#FFD600] text-[#FFD600]" />
                  ))}
                </div>
                <div className="font-semibold text-[#0A0A0A]">{t.name}</div>
                <div className="text-sm text-[#475569]">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
